module.exports = __webpack_public_path__ + "img/goal.f12a4bfb.png";